import { render, staticRenderFns } from "./CreateNotificationConfigBtn.vue?vue&type=template&id=395c9626&"
import script from "./CreateNotificationConfigBtn.vue?vue&type=script&lang=js&"
export * from "./CreateNotificationConfigBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports